import { render, staticRenderFns } from "./DiamondOrder.vue?vue&type=template&id=58a21c82&scoped=true&"
import script from "./DiamondOrder.vue?vue&type=script&lang=js&"
export * from "./DiamondOrder.vue?vue&type=script&lang=js&"
import style0 from "./DiamondOrder.vue?vue&type=style&index=0&id=58a21c82&lang=less&scoped=true&"
import style1 from "./DiamondOrder.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a21c82",
  null
  
)

export default component.exports